import { useCalculatorStore } from "../store/calculatorStore";
import { HistoryPanel } from "./HistoryPanel";
import { SequencePanel } from "./SequencePanel";
import { MarketplacePanel } from "./MarketplacePanel";
import { WorkspacePanel } from "./WorkspacePanel";
import { SettingsPanel } from "./SettingsPanel";
import { SessionTabs } from "./SessionTabs";
import { TerminalShell } from "./TerminalShell";

export function Calculator() {
  const { activeTab } = useCalculatorStore();

  if (activeTab === "history") {
    return <HistoryPanel />;
  }

  if (activeTab === "sequences") {
    return <SequencePanel />;
  }

  if (activeTab === "marketplace") {
    return <MarketplacePanel />;
  }

  if (activeTab === "files") {
    return <WorkspacePanel />;
  }

  if (activeTab === "settings") {
    return <SettingsPanel />;
  }

  return (
    <main className="calculator calculator-terminal">
      <SessionTabs />
      <TerminalShell />
    </main>
  );
}
